import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ApiRoutesService} from "./api-routes.service";
import {Observable} from "rxjs";
import {Coupon} from "../models/coupon.model";

@Injectable({
  providedIn: 'root'
})
export class CouponService {

  readonly #httpClient = inject(HttpClient);
  readonly #apiRoutes = inject(ApiRoutesService);

  public getCouponByName(name: string): Observable<Coupon> {
    return this.#httpClient.get<Coupon>(this.#apiRoutes.coupon() + "/" + name);
  }
}
